.weeknr {
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--ax-text-neutral-subtle);
    font-size: 14px;
    font-style: normal;
    font-weight: 300;
    cursor: default;
}

.weekday {
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    cursor: default;
}
